import React from 'react';

import { token } from '@atlaskit/tokens';

export const TopLinksEmptyStateIllustration = () => (
	<svg
		width="58"
		height="60"
		viewBox="0 0 58 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="presentation"
	>
		<path
			d="M5.37109 50.0781C5.37109 50.0781 30.9568 53.1209 44.1256 49.9399V3.60754C44.1256 3.60754 23.2435 8.72303 5.37109 3.33118C5.37109 3.33118 5.65298 50.2881 5.37109 50.0809V50.0781Z"
			fill={token('color.background.accent.gray.subtler')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.6446 16.4585H10.8535V14.5239H38.6446V16.4585Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.6446 23.2653H10.8535V21.3308H38.6446V23.2653Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.6446 30.0749H10.8535V28.1404H38.6446V30.0749Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M38.6446 36.8818H10.8535V34.9472H38.6446V36.8818Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			d="M52.3777 50.0975C52.4883 49.4784 52.5463 48.8207 52.5463 48.1242C52.5463 47.4278 52.4883 46.7507 52.375 46.1261C51.7062 42.398 49.1139 40.0986 45.4825 39.5072C44.8634 39.4077 44.214 39.3552 43.5369 39.3552C42.8321 39.3552 42.155 39.4105 41.5111 39.5183C37.8769 40.1263 35.2902 42.4173 34.6186 46.1261C34.5053 46.7535 34.4473 47.4195 34.4473 48.1242C34.4473 48.829 34.5053 49.4784 34.6158 50.0975C35.2819 53.8008 37.8686 56.0973 41.5111 56.7053C42.155 56.8131 42.8321 56.8684 43.5369 56.8684C44.214 56.8684 44.8634 56.8159 45.4825 56.7164C49.1194 56.125 51.7145 53.8229 52.3777 50.0975Z"
			fill={token('color.chart.blue.bolder.hovered')}
		/>
		<path
			d="M44.1254 39.3718C43.9319 39.3635 43.7357 39.358 43.5339 39.358C42.8292 39.358 42.1521 39.4132 41.5082 39.521C37.874 40.1263 35.2872 42.4201 34.6157 46.1289C34.5024 46.7562 34.4443 47.4223 34.4443 48.127C34.4443 48.8234 34.5024 49.4812 34.6129 50.1002C34.682 50.4788 34.7732 50.8381 34.881 51.1891C38.2609 50.9791 41.4474 50.5894 44.1226 49.9427V39.3718H44.1254Z"
			fill={token('color.text.accent.blue.bolder')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M49.5754 49.2905H37.8438V47.3559H49.5754V49.2905Z"
			fill={token('color.icon.inverse')}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M42.7432 54.1876V42.4588H44.6777V54.1876H42.7432Z"
			fill={token('color.icon.inverse')}
		/>
	</svg>
);
